import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import CrecheTeam from "./creche-team";
import NextEvent from "./next-event";
import srcImgVieCreche from "../../../../styles/img/icon-vie-creche.svg";
import {
  fetchEvent,
  getNextEventParticipants,
} from "./next-event/Next-event.ducks";
import { fetchTeam } from "./creche-team/Creche-team.ducks";
import { withTranslation } from 'react-i18next';

const IconCrecheLife = () => (
  <object
    data={srcImgVieCreche}
    style={{
      width: "70px",
      height: "70px",
      pointerEvents: "none",
      cursor: "pointer",
    }}
    type="image/svg+xml"
    className="img-fluid"
  />
);
class CrecheLife extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: {},
    };
  }

  componentDidMount() {
    this.props.fetchEvent(localStorage.getItem("token"));
    this.props.fetchTeam(localStorage.getItem("token"));
  }

  render() {
    const { t } = this.props;
    const { dataEvent, dataTeam } = this.props.life;

    return (
      <section className="py-5">
        <h2 className="d-flex align-items-center justify-content-center">
          <IconCrecheLife className="img-fluid" />
          <span className="mt-4 ml-4">{t('creche_life.title')}</span>
        </h2>

        <div className="container">
          <div className="row">
            {nextEvent(dataEvent) ? (
              <div className="col-md-6">
                <NextEvent dataEvent={dataEvent} />
              </div>
            ) : (
              <div className="col-md-6"></div>
            )}
            <div className="col-md-6">
              <CrecheTeam dataTeam={dataTeam} />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ life }) => ({ life });

const mapDispatchToProps = { fetchEvent, fetchTeam, getNextEventParticipants };

const withStore = connect(mapStateToProps, mapDispatchToProps);

export default withStore(withTranslation()(CrecheLife));

function nextEvent(dataEvent) {
  if (!_.isEmpty(dataEvent.event)) {
    return true;
  }
}
